import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../../../context/Modal';
import { Button } from '../../../UI';
import React from 'react';
import { useMutation } from '@apollo/client';
import {
  CLEAR_ASSET_ALERTS,
  DELETE_ASSET_ALERT,
  LIST_ASSET_ALERTS,
} from '../../../../http/apollo-queries';
import { toast } from 'react-toastify';

interface DeleteModalProps {
  id?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ id }) => {
  const { closeModal } = useModalContext();
  const { t } = useTranslation();

  const [clearAlerts, { loading: loadingClearAlerts }] = useMutation(
    CLEAR_ASSET_ALERTS,
    {
      refetchQueries: [
        {
          query: LIST_ASSET_ALERTS,
        },
      ],
      awaitRefetchQueries: true,
      onCompleted: () => closeModal(),
      onError: (e) => {
        toast.error(e.message);
        closeModal();
      },
    }
  );

  const [deleteAlert, { loading: loadingDeleteAlert }] = useMutation(
    DELETE_ASSET_ALERT,
    {
      refetchQueries: [
        {
          query: LIST_ASSET_ALERTS,
        },
      ],
      awaitRefetchQueries: true,
      onCompleted: () => closeModal(),
      onError: (e) => {
        toast.error(e.message);
        closeModal();
      },
    }
  );

  return (
    <div className="text-center mx-32 mb-20">
      <h3 className="text-lg font-semibold">
        {t(
          id
            ? 'alerts.deleteAlertModal.question'
            : 'alerts.deleteAllModal.question'
        )}
      </h3>
      <p className="text-md text-grey-50 font-normal mt-2">
        {t('alerts.deleteRemark')}
      </p>
      <div className="mt-10 flex gap-2 justify-center">
        <Button
          size="small"
          variant="secondary"
          onClick={closeModal}
          buttonClass={'px-2 py-4'}
        >
          {t('alerts.cancel')}
        </Button>
        <Button
          size="small"
          variant={'negative'}
          buttonClass={'px-2 py-4'}
          onClick={() =>
            id ? deleteAlert({ variables: { alertId: id } }) : clearAlerts()
          }
          disabled={loadingDeleteAlert || loadingClearAlerts}
          loading={loadingDeleteAlert || loadingClearAlerts}
        >
          {t('alerts.delete')}
        </Button>
      </div>
    </div>
  );
};

export default DeleteModal;
